import React from "react";
import PageHeader from "../../PageHeader";
import ViewOMR from "./ViewOMR";
import { ReactComponent as CoursesIcon } from "../../../images/courseimage/coursesicon.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";

function OmrScan() {
  const classes = useStyles();


  const Heading = [
    {
      id: 1,
      pageicon: <CoursesIcon />,
      mainheading: "Read OMR",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      // addbtntext: "Add New OMR",
      // addbtnicon: <AddIcon />,
      // addbtnstyle: "bluebtn",
      // path: "/admin/omr/AddOmr",
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <div
        className={`${classes.w100} ${classes.h49vh} ${classes.bgwhite} 
        ${classes.borderradius6px} ${classes.mt1} ${classes.h76vh} ${classes.overflowhidden} ${classes.showscroll}`}
      style={{scrollbarWidth:'none'}}
      >
      <ViewOMR />
      </div>
    </div>
  );
}
export default OmrScan;
